import { TmcContextService } from './../../../../../common/tmc-context.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppServerAPI } from '@sdbn/common';
import { ResponseMessage } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';

import { MovementOrderRequest } from '../../model/sac-client.model';

@Component({
    selector: 'app-create-moving-order',
    templateUrl: './create-moving-order.component.html',
    styleUrls: ['./create-moving-order.component.scss'],
    standalone: false
})
export class CreateMovingOrderComponent implements OnInit {

  withTransport: boolean;

  responseMessages: ResponseMessage[];

  selectedVehicle: number;

  selectedTransport: number;

  targetStationId: number;

  constructor(
    private appServerAPI: AppServerAPI,
    private tmcContextService: TmcContextService,
    private dialog: MatDialogRef<CreateMovingOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.targetStationId = this.data.station.id;
  }

  get createMovementOrderEnabled(): boolean {
    return this.selectedVehicle != null;
  }

  createMovementOrder() {

    const movementOrderRequest = new MovementOrderRequest({
      transportId: this.selectedTransport != null ? this.selectedTransport : null,
      vehicleId: this.selectedVehicle != null ? this.selectedVehicle : null,
      targetStationId: this.targetStationId
    });

    console.log('movement order is', movementOrderRequest);

    this.appServerAPI.execute<ServiceResponse>('/client/control/sac-client/create-moving-order', movementOrderRequest).subscribe(
      response => {

        this.tmcContextService.forceRefreshOfStationUsages();
        this.responseMessages = response.responseMessages;

        this.dialog.close(true);

      }, error => {
        console.log('Unexpected error' + error);
      }
    );

  }

  vehicleSelected(vehicleId: number) {
    this.selectedVehicle = vehicleId;
  }

  transportSelected(transportId: number) {
    this.selectedTransport = transportId;
  }

}
